const Home = {
    headline: 'Hello,',
    myName: 'My Name is',
    name: 'Ryan Afrizal',
    githubProfile: 'https://github.com/tisoga',
    desc: "I am a Full Stack Developer, Mobile Developer and also a Python Programmer from Bandung, West Java, Indonesia. Thanks For Viewing My Portfolio. Also Check my Github profile in link below."
}

export default Home